var _Defs, _Path, _Use, _Use2, _Use3, _Use4, _Use5, _Use6, _Use7, _Use8, _Use9, _Use0, _Use1, _Use10, _Use11, _Use12, _Use13, _Use14, _Use15, _Use16, _Use17, _Use18, _Use19, _Use20, _Use21, _Use22, _Use23, _Use24, _Use25, _Use26, _Use27, _Use28, _Use29, _Use30, _Use31, _Use32, _Use33, _Use34, _Use35, _Use36, _Use37, _Use38, _Use39, _Use40, _Use41, _Use42, _Use43, _Use44, _Use45, _Use46, _Use47, _Use48, _Use49, _Use50, _Use51, _Use52, _Use53, _Use54, _Use55, _Use56, _Use57, _Use58, _Use59, _Use60, _Use61, _Use62, _Use63, _Use64, _Use65, _Use66, _Use67, _Use68, _Use69, _Use70, _Use71, _Use72, _Use73, _Use74, _Use75, _Use76, _Use77, _Use78, _Use79, _Use80, _Use81, _Use82, _Use83, _Use84, _Use85, _Use86, _Use87, _Use88, _Use89, _Use90, _Use91, _Use92, _Use93, _Use94, _Use95, _Use96, _Use97, _Use98, _Use99, _Use100, _Use101, _Use102, _Use103, _Use104, _Use105, _Use106, _Use107, _Use108, _Use109, _Use110, _Use111, _Use112, _Use113, _Use114, _Use115, _Use116, _Use117, _Use118, _Use119, _Use120, _Use121, _Use122, _Use123, _Use124, _Use125, _Use126, _Use127, _Use128, _Use129, _Use130, _Use131, _Use132, _Use133, _Use134, _Use135, _Use136, _Use137, _Use138, _Use139, _Use140, _Use141, _Use142, _Use143, _Use144, _Use145, _Use146, _Use147, _Use148, _Use149, _Use150, _Use151, _Use152, _Use153, _Use154, _Use155, _Use156, _Use157, _Use158, _Use159, _Use160, _Use161, _Use162, _Use163, _Use164, _Use165, _Use166, _Use167, _Use168, _Use169, _Use170, _Use171, _Use172, _Use173, _Use174, _Use175, _Use176, _Use177, _Use178, _Use179, _Use180, _Use181, _Use182, _Use183, _Use184, _Use185, _Use186, _Use187, _Use188, _Use189, _Use190, _Use191, _Use192, _Use193, _Use194, _Use195, _Use196, _Use197, _Use198, _Use199, _Use200, _Use201, _Use202, _Use203, _Use204, _Use205, _Use206, _Use207, _Use208, _Use209, _Use210, _Use211, _Use212, _Use213, _Use214, _Use215, _Use216, _Use217, _Use218, _Use219, _Use220, _Use221, _Use222, _Use223, _Use224, _Use225, _Use226, _Use227, _Use228, _Use229, _Use230, _Use231, _Use232, _Use233, _Use234, _Use235, _Use236, _Use237, _Use238, _Use239, _Use240, _Use241, _Use242, _Use243, _Use244, _Use245, _Use246, _Use247, _Use248, _Use249, _Use250, _Use251, _Use252, _Use253, _Use254, _Use255, _Use256, _Use257, _Use258, _Use259, _Use260, _Use261, _Use262, _Use263, _Use264, _Use265, _Use266, _Use267, _Use268, _Use269, _Use270, _Use271, _Use272, _Use273, _Use274, _Use275, _Use276, _Use277, _Use278, _Use279, _Use280, _Use281, _Use282, _Use283, _Use284, _Use285, _Use286, _Use287, _Use288, _Use289, _Use290, _Use291, _Use292, _Use293, _Use294, _Use295, _Use296, _Use297, _Use298, _Use299, _Use300, _Use301, _Use302, _Use303, _Use304, _Use305, _Use306, _Use307, _Use308, _Use309, _Use310, _Use311, _Use312, _Use313, _Use314, _Use315, _Use316, _Use317, _Use318, _Use319, _Use320, _Use321, _Use322, _Use323, _Use324, _Use325, _Use326, _Use327, _Use328, _Use329, _Use330, _Use331, _Use332, _Use333, _Use334, _Use335, _Use336, _Use337, _Use338, _Use339, _Use340, _Use341, _Use342, _Use343, _Use344, _Use345, _Use346, _Use347, _Use348, _Use349, _Use350, _Use351, _Use352, _Use353, _Use354, _Use355, _Use356, _Use357, _Use358, _Use359, _Use360, _Use361, _Use362, _Use363, _Use364, _Use365, _Use366, _Use367, _Use368, _Use369, _Use370, _Use371, _Use372, _Use373, _Use374, _Use375, _Use376, _Use377, _Use378, _Use379, _Use380, _Use381, _Use382, _Use383, _Use384, _Use385, _Use386, _Use387, _Use388, _Use389, _Use390, _Use391, _Use392, _Use393, _Use394, _Use395, _Use396, _Use397, _Use398, _Use399, _Use400, _Use401, _Use402, _Use403, _Use404, _Use405, _Use406, _Use407, _Use408, _Use409, _Use410, _Use411, _Use412, _Use413, _Use414, _Use415, _Use416, _Use417, _Use418, _Use419, _Use420, _Use421, _Use422, _Use423, _Use424, _Use425, _Use426, _Use427, _Use428, _Use429, _Use430, _Use431, _Use432, _Use433, _Use434, _Use435, _Use436, _Use437, _Use438, _Use439, _Use440, _Use441, _Use442, _Use443, _Use444, _Use445, _Use446, _Use447, _Use448, _Use449, _Use450, _Use451, _Use452, _Use453, _Use454, _Use455, _Use456, _Use457, _Use458, _Use459, _Use460, _Use461, _Use462, _Use463, _Use464, _Use465, _Use466, _Use467, _Use468, _Use469, _Use470, _Use471, _Use472, _Use473, _Use474, _Use475, _Use476, _Use477, _Use478, _Use479, _Use480, _Use481, _Use482, _Use483, _Use484, _Use485, _Use486, _Use487, _Use488, _Use489, _Use490, _Use491, _Use492, _Use493, _Use494, _Use495, _Use496, _Use497, _Use498, _Use499, _Use500, _Use501, _Use502, _Use503, _Use504, _Use505, _Use506, _Use507, _Use508, _Use509, _Use510, _Use511, _Use512, _Use513, _Use514, _Use515, _Use516, _Use517, _Use518, _Use519, _Use520, _Use521, _Use522, _Use523, _Use524, _Use525, _Use526, _Use527, _Use528, _Use529, _Use530, _Use531, _Use532, _Use533, _Use534, _Use535, _Use536, _Use537, _Use538, _Use539, _Use540, _Use541, _Use542, _Use543, _Use544, _Use545, _Use546, _Use547, _Use548, _Use549, _Use550, _Use551, _Use552, _Use553, _Use554, _Use555, _Use556, _Use557, _Use558, _Use559, _Use560, _Use561, _Use562, _Use563, _Use564, _Use565, _Use566, _Use567, _Use568, _Use569, _Use570, _Use571, _Use572, _Use573, _Use574, _Use575, _Use576, _Use577, _Use578, _Use579, _Use580, _Use581, _Use582, _Use583, _Use584, _Use585, _Use586, _Use587, _Use588, _Use589, _Use590, _Use591, _Use592, _Use593, _Use594, _Use595, _Use596, _Use597, _Use598, _Use599, _Use600, _Use601, _Use602, _Use603, _Use604, _Use605, _Use606, _Use607, _Use608, _Use609, _Use610, _Use611, _Use612, _Use613, _Use614, _Use615, _Use616, _Use617, _Use618, _Use619, _Use620, _Use621, _Use622, _Use623, _Use624, _Use625, _Use626, _Use627, _Path2, _Path3, _Path4, _Path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, Path, Use } from "react-native-svg";
var SvgQrCodeAppStore = function SvgQrCodeAppStore(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    viewBox: "0 0 1667 1667"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Path, {
    id: "qr_code_app_store_svg__a",
    fill: "#000",
    d: "M0 0h42v42H0z"
  }))), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h1667v1667H0z"
  })), _Use || (_Use = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 56
  })), _Use2 || (_Use2 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 56
  })), _Use3 || (_Use3 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 56
  })), _Use4 || (_Use4 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 56
  })), _Use5 || (_Use5 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 56
  })), _Use6 || (_Use6 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 56
  })), _Use7 || (_Use7 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 56
  })), _Use8 || (_Use8 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 56
  })), _Use9 || (_Use9 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 56
  })), _Use0 || (_Use0 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 56
  })), _Use1 || (_Use1 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 56
  })), _Use10 || (_Use10 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 56
  })), _Use11 || (_Use11 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 98
  })), _Use12 || (_Use12 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 98
  })), _Use13 || (_Use13 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 98
  })), _Use14 || (_Use14 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 98
  })), _Use15 || (_Use15 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 98
  })), _Use16 || (_Use16 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 98
  })), _Use17 || (_Use17 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 98
  })), _Use18 || (_Use18 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 98
  })), _Use19 || (_Use19 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 98
  })), _Use20 || (_Use20 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 98
  })), _Use21 || (_Use21 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 98
  })), _Use22 || (_Use22 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 140
  })), _Use23 || (_Use23 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 140
  })), _Use24 || (_Use24 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 140
  })), _Use25 || (_Use25 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 140
  })), _Use26 || (_Use26 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 140
  })), _Use27 || (_Use27 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 140
  })), _Use28 || (_Use28 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 140
  })), _Use29 || (_Use29 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 140
  })), _Use30 || (_Use30 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 140
  })), _Use31 || (_Use31 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 140
  })), _Use32 || (_Use32 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 182
  })), _Use33 || (_Use33 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 182
  })), _Use34 || (_Use34 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 182
  })), _Use35 || (_Use35 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 182
  })), _Use36 || (_Use36 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 182
  })), _Use37 || (_Use37 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 182
  })), _Use38 || (_Use38 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 182
  })), _Use39 || (_Use39 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 182
  })), _Use40 || (_Use40 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 182
  })), _Use41 || (_Use41 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 182
  })), _Use42 || (_Use42 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 224
  })), _Use43 || (_Use43 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 224
  })), _Use44 || (_Use44 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 224
  })), _Use45 || (_Use45 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 224
  })), _Use46 || (_Use46 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 224
  })), _Use47 || (_Use47 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 224
  })), _Use48 || (_Use48 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 224
  })), _Use49 || (_Use49 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 224
  })), _Use50 || (_Use50 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 224
  })), _Use51 || (_Use51 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 224
  })), _Use52 || (_Use52 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 224
  })), _Use53 || (_Use53 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 224
  })), _Use54 || (_Use54 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 266
  })), _Use55 || (_Use55 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 266
  })), _Use56 || (_Use56 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 266
  })), _Use57 || (_Use57 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 266
  })), _Use58 || (_Use58 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 266
  })), _Use59 || (_Use59 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 266
  })), _Use60 || (_Use60 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 266
  })), _Use61 || (_Use61 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 266
  })), _Use62 || (_Use62 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 266
  })), _Use63 || (_Use63 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 266
  })), _Use64 || (_Use64 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 266
  })), _Use65 || (_Use65 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 266
  })), _Use66 || (_Use66 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 308
  })), _Use67 || (_Use67 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 308
  })), _Use68 || (_Use68 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 308
  })), _Use69 || (_Use69 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 308
  })), _Use70 || (_Use70 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 308
  })), _Use71 || (_Use71 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 308
  })), _Use72 || (_Use72 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 308
  })), _Use73 || (_Use73 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 308
  })), _Use74 || (_Use74 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 308
  })), _Use75 || (_Use75 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 308
  })), _Use76 || (_Use76 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 308
  })), _Use77 || (_Use77 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 350
  })), _Use78 || (_Use78 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 350
  })), _Use79 || (_Use79 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 350
  })), _Use80 || (_Use80 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 350
  })), _Use81 || (_Use81 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 350
  })), _Use82 || (_Use82 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 350
  })), _Use83 || (_Use83 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 350
  })), _Use84 || (_Use84 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 350
  })), _Use85 || (_Use85 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 350
  })), _Use86 || (_Use86 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 350
  })), _Use87 || (_Use87 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 350
  })), _Use88 || (_Use88 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 140,
    y: 392
  })), _Use89 || (_Use89 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 392
  })), _Use90 || (_Use90 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 392
  })), _Use91 || (_Use91 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 308,
    y: 392
  })), _Use92 || (_Use92 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 392
  })), _Use93 || (_Use93 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 392
  })), _Use94 || (_Use94 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 392
  })), _Use95 || (_Use95 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 392
  })), _Use96 || (_Use96 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 392
  })), _Use97 || (_Use97 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 392
  })), _Use98 || (_Use98 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 392
  })), _Use99 || (_Use99 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 392
  })), _Use100 || (_Use100 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 392
  })), _Use101 || (_Use101 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 392
  })), _Use102 || (_Use102 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 392
  })), _Use103 || (_Use103 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 392
  })), _Use104 || (_Use104 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 392
  })), _Use105 || (_Use105 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 392
  })), _Use106 || (_Use106 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 392
  })), _Use107 || (_Use107 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 392
  })), _Use108 || (_Use108 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 392
  })), _Use109 || (_Use109 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 392
  })), _Use110 || (_Use110 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1484,
    y: 392
  })), _Use111 || (_Use111 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 392
  })), _Use112 || (_Use112 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 392
  })), _Use113 || (_Use113 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 98,
    y: 434
  })), _Use114 || (_Use114 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 140,
    y: 434
  })), _Use115 || (_Use115 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 266,
    y: 434
  })), _Use116 || (_Use116 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 350,
    y: 434
  })), _Use117 || (_Use117 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 434
  })), _Use118 || (_Use118 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 434
  })), _Use119 || (_Use119 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 434
  })), _Use120 || (_Use120 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 434
  })), _Use121 || (_Use121 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 434
  })), _Use122 || (_Use122 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 434
  })), _Use123 || (_Use123 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 434
  })), _Use124 || (_Use124 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 434
  })), _Use125 || (_Use125 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 434
  })), _Use126 || (_Use126 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 434
  })), _Use127 || (_Use127 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 434
  })), _Use128 || (_Use128 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 434
  })), _Use129 || (_Use129 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 434
  })), _Use130 || (_Use130 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1442,
    y: 434
  })), _Use131 || (_Use131 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 476
  })), _Use132 || (_Use132 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 98,
    y: 476
  })), _Use133 || (_Use133 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 140,
    y: 476
  })), _Use134 || (_Use134 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 476
  })), _Use135 || (_Use135 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 476
  })), _Use136 || (_Use136 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 308,
    y: 476
  })), _Use137 || (_Use137 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 476
  })), _Use138 || (_Use138 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 476
  })), _Use139 || (_Use139 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 476
  })), _Use140 || (_Use140 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 476
  })), _Use141 || (_Use141 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 476
  })), _Use142 || (_Use142 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 476
  })), _Use143 || (_Use143 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 476
  })), _Use144 || (_Use144 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 476
  })), _Use145 || (_Use145 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 476
  })), _Use146 || (_Use146 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 476
  })), _Use147 || (_Use147 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 476
  })), _Use148 || (_Use148 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 476
  })), _Use149 || (_Use149 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 476
  })), _Use150 || (_Use150 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 476
  })), _Use151 || (_Use151 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 476
  })), _Use152 || (_Use152 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 98,
    y: 518
  })), _Use153 || (_Use153 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 140,
    y: 518
  })), _Use154 || (_Use154 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 518
  })), _Use155 || (_Use155 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 518
  })), _Use156 || (_Use156 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 518
  })), _Use157 || (_Use157 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 518
  })), _Use158 || (_Use158 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 518
  })), _Use159 || (_Use159 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 518
  })), _Use160 || (_Use160 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 518
  })), _Use161 || (_Use161 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 518
  })), _Use162 || (_Use162 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 518
  })), _Use163 || (_Use163 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 518
  })), _Use164 || (_Use164 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 518
  })), _Use165 || (_Use165 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 518
  })), _Use166 || (_Use166 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 518
  })), _Use167 || (_Use167 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 518
  })), _Use168 || (_Use168 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 518
  })), _Use169 || (_Use169 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 518
  })), _Use170 || (_Use170 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 518
  })), _Use171 || (_Use171 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 518
  })), _Use172 || (_Use172 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 518
  })), _Use173 || (_Use173 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 98,
    y: 560
  })), _Use174 || (_Use174 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 560
  })), _Use175 || (_Use175 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 560
  })), _Use176 || (_Use176 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 308,
    y: 560
  })), _Use177 || (_Use177 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 350,
    y: 560
  })), _Use178 || (_Use178 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 560
  })), _Use179 || (_Use179 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 560
  })), _Use180 || (_Use180 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 560
  })), _Use181 || (_Use181 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 560
  })), _Use182 || (_Use182 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 560
  })), _Use183 || (_Use183 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 560
  })), _Use184 || (_Use184 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 560
  })), _Use185 || (_Use185 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 560
  })), _Use186 || (_Use186 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 560
  })), _Use187 || (_Use187 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 560
  })), _Use188 || (_Use188 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 560
  })), _Use189 || (_Use189 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 560
  })), _Use190 || (_Use190 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 560
  })), _Use191 || (_Use191 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 560
  })), _Use192 || (_Use192 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 560
  })), _Use193 || (_Use193 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 560
  })), _Use194 || (_Use194 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 560
  })), _Use195 || (_Use195 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 560
  })), _Use196 || (_Use196 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 560
  })), _Use197 || (_Use197 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 560
  })), _Use198 || (_Use198 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1484,
    y: 560
  })), _Use199 || (_Use199 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 560
  })), _Use200 || (_Use200 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 560
  })), _Use201 || (_Use201 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 98,
    y: 602
  })), _Use202 || (_Use202 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 140,
    y: 602
  })), _Use203 || (_Use203 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 602
  })), _Use204 || (_Use204 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 602
  })), _Use205 || (_Use205 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 266,
    y: 602
  })), _Use206 || (_Use206 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 350,
    y: 602
  })), _Use207 || (_Use207 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 602
  })), _Use208 || (_Use208 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 602
  })), _Use209 || (_Use209 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 602
  })), _Use210 || (_Use210 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 602
  })), _Use211 || (_Use211 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 602
  })), _Use212 || (_Use212 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 602
  })), _Use213 || (_Use213 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 602
  })), _Use214 || (_Use214 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 602
  })), _Use215 || (_Use215 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 602
  })), _Use216 || (_Use216 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 602
  })), _Use217 || (_Use217 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 602
  })), _Use218 || (_Use218 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 602
  })), _Use219 || (_Use219 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 602
  })), _Use220 || (_Use220 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1442,
    y: 602
  })), _Use221 || (_Use221 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1484,
    y: 602
  })), _Use222 || (_Use222 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 644
  })), _Use223 || (_Use223 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 98,
    y: 644
  })), _Use224 || (_Use224 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 644
  })), _Use225 || (_Use225 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 644
  })), _Use226 || (_Use226 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 308,
    y: 644
  })), _Use227 || (_Use227 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 644
  })), _Use228 || (_Use228 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 644
  })), _Use229 || (_Use229 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 644
  })), _Use230 || (_Use230 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 644
  })), _Use231 || (_Use231 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 644
  })), _Use232 || (_Use232 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 644
  })), _Use233 || (_Use233 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 644
  })), _Use234 || (_Use234 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 644
  })), _Use235 || (_Use235 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 644
  })), _Use236 || (_Use236 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 644
  })), _Use237 || (_Use237 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 644
  })), _Use238 || (_Use238 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 644
  })), _Use239 || (_Use239 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 644
  })), _Use240 || (_Use240 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 644
  })), _Use241 || (_Use241 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 644
  })), _Use242 || (_Use242 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1442,
    y: 644
  })), _Use243 || (_Use243 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 644
  })), _Use244 || (_Use244 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 644
  })), _Use245 || (_Use245 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 686
  })), _Use246 || (_Use246 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 686
  })), _Use247 || (_Use247 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 350,
    y: 686
  })), _Use248 || (_Use248 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 686
  })), _Use249 || (_Use249 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 686
  })), _Use250 || (_Use250 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 686
  })), _Use251 || (_Use251 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 686
  })), _Use252 || (_Use252 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 686
  })), _Use253 || (_Use253 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 686
  })), _Use254 || (_Use254 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 686
  })), _Use255 || (_Use255 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 686
  })), _Use256 || (_Use256 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 686
  })), _Use257 || (_Use257 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 728
  })), _Use258 || (_Use258 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 728
  })), _Use259 || (_Use259 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 266,
    y: 728
  })), _Use260 || (_Use260 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 308,
    y: 728
  })), _Use261 || (_Use261 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 350,
    y: 728
  })), _Use262 || (_Use262 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 728
  })), _Use263 || (_Use263 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 728
  })), _Use264 || (_Use264 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 728
  })), _Use265 || (_Use265 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 728
  })), _Use266 || (_Use266 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 728
  })), _Use267 || (_Use267 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 728
  })), _Use268 || (_Use268 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 728
  })), _Use269 || (_Use269 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 728
  })), _Use270 || (_Use270 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 728
  })), _Use271 || (_Use271 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 728
  })), _Use272 || (_Use272 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 728
  })), _Use273 || (_Use273 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 728
  })), _Use274 || (_Use274 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 728
  })), _Use275 || (_Use275 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 728
  })), _Use276 || (_Use276 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 728
  })), _Use277 || (_Use277 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 728
  })), _Use278 || (_Use278 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1484,
    y: 728
  })), _Use279 || (_Use279 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 728
  })), _Use280 || (_Use280 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 770
  })), _Use281 || (_Use281 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 98,
    y: 770
  })), _Use282 || (_Use282 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 140,
    y: 770
  })), _Use283 || (_Use283 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 770
  })), _Use284 || (_Use284 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 266,
    y: 770
  })), _Use285 || (_Use285 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 350,
    y: 770
  })), _Use286 || (_Use286 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 770
  })), _Use287 || (_Use287 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 770
  })), _Use288 || (_Use288 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 770
  })), _Use289 || (_Use289 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 770
  })), _Use290 || (_Use290 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 770
  })), _Use291 || (_Use291 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 770
  })), _Use292 || (_Use292 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 770
  })), _Use293 || (_Use293 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 770
  })), _Use294 || (_Use294 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 770
  })), _Use295 || (_Use295 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 770
  })), _Use296 || (_Use296 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 770
  })), _Use297 || (_Use297 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1484,
    y: 770
  })), _Use298 || (_Use298 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 812
  })), _Use299 || (_Use299 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 812
  })), _Use300 || (_Use300 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 812
  })), _Use301 || (_Use301 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 266,
    y: 812
  })), _Use302 || (_Use302 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 308,
    y: 812
  })), _Use303 || (_Use303 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 812
  })), _Use304 || (_Use304 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 812
  })), _Use305 || (_Use305 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 812
  })), _Use306 || (_Use306 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 812
  })), _Use307 || (_Use307 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 812
  })), _Use308 || (_Use308 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 812
  })), _Use309 || (_Use309 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 812
  })), _Use310 || (_Use310 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 812
  })), _Use311 || (_Use311 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 812
  })), _Use312 || (_Use312 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 812
  })), _Use313 || (_Use313 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 812
  })), _Use314 || (_Use314 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 812
  })), _Use315 || (_Use315 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 812
  })), _Use316 || (_Use316 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1442,
    y: 812
  })), _Use317 || (_Use317 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 812
  })), _Use318 || (_Use318 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 812
  })), _Use319 || (_Use319 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 854
  })), _Use320 || (_Use320 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 854
  })), _Use321 || (_Use321 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 266,
    y: 854
  })), _Use322 || (_Use322 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 854
  })), _Use323 || (_Use323 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 854
  })), _Use324 || (_Use324 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 854
  })), _Use325 || (_Use325 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 854
  })), _Use326 || (_Use326 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 854
  })), _Use327 || (_Use327 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 854
  })), _Use328 || (_Use328 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 854
  })), _Use329 || (_Use329 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 854
  })), _Use330 || (_Use330 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 854
  })), _Use331 || (_Use331 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 854
  })), _Use332 || (_Use332 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 854
  })), _Use333 || (_Use333 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 854
  })), _Use334 || (_Use334 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 854
  })), _Use335 || (_Use335 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 98,
    y: 896
  })), _Use336 || (_Use336 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 140,
    y: 896
  })), _Use337 || (_Use337 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 896
  })), _Use338 || (_Use338 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 896
  })), _Use339 || (_Use339 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 308,
    y: 896
  })), _Use340 || (_Use340 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 896
  })), _Use341 || (_Use341 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 896
  })), _Use342 || (_Use342 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 896
  })), _Use343 || (_Use343 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 896
  })), _Use344 || (_Use344 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 896
  })), _Use345 || (_Use345 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 896
  })), _Use346 || (_Use346 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 896
  })), _Use347 || (_Use347 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 896
  })), _Use348 || (_Use348 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 896
  })), _Use349 || (_Use349 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 896
  })), _Use350 || (_Use350 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 896
  })), _Use351 || (_Use351 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 896
  })), _Use352 || (_Use352 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 896
  })), _Use353 || (_Use353 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 896
  })), _Use354 || (_Use354 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 896
  })), _Use355 || (_Use355 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 896
  })), _Use356 || (_Use356 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1442,
    y: 896
  })), _Use357 || (_Use357 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1484,
    y: 896
  })), _Use358 || (_Use358 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 896
  })), _Use359 || (_Use359 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 896
  })), _Use360 || (_Use360 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 938
  })), _Use361 || (_Use361 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 98,
    y: 938
  })), _Use362 || (_Use362 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 938
  })), _Use363 || (_Use363 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 938
  })), _Use364 || (_Use364 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 350,
    y: 938
  })), _Use365 || (_Use365 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 938
  })), _Use366 || (_Use366 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 938
  })), _Use367 || (_Use367 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 938
  })), _Use368 || (_Use368 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 938
  })), _Use369 || (_Use369 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 938
  })), _Use370 || (_Use370 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 938
  })), _Use371 || (_Use371 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 938
  })), _Use372 || (_Use372 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 938
  })), _Use373 || (_Use373 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 980
  })), _Use374 || (_Use374 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 140,
    y: 980
  })), _Use375 || (_Use375 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 980
  })), _Use376 || (_Use376 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 266,
    y: 980
  })), _Use377 || (_Use377 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 308,
    y: 980
  })), _Use378 || (_Use378 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 350,
    y: 980
  })), _Use379 || (_Use379 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 980
  })), _Use380 || (_Use380 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 980
  })), _Use381 || (_Use381 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 980
  })), _Use382 || (_Use382 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 980
  })), _Use383 || (_Use383 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 980
  })), _Use384 || (_Use384 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 980
  })), _Use385 || (_Use385 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 980
  })), _Use386 || (_Use386 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 980
  })), _Use387 || (_Use387 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 980
  })), _Use388 || (_Use388 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 980
  })), _Use389 || (_Use389 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 980
  })), _Use390 || (_Use390 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 980
  })), _Use391 || (_Use391 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 980
  })), _Use392 || (_Use392 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 980
  })), _Use393 || (_Use393 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 980
  })), _Use394 || (_Use394 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 1022
  })), _Use395 || (_Use395 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 1022
  })), _Use396 || (_Use396 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 350,
    y: 1022
  })), _Use397 || (_Use397 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 1022
  })), _Use398 || (_Use398 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 1022
  })), _Use399 || (_Use399 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 1022
  })), _Use400 || (_Use400 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 1022
  })), _Use401 || (_Use401 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 1022
  })), _Use402 || (_Use402 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 1022
  })), _Use403 || (_Use403 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 1022
  })), _Use404 || (_Use404 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 1022
  })), _Use405 || (_Use405 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 1022
  })), _Use406 || (_Use406 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 1022
  })), _Use407 || (_Use407 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 1022
  })), _Use408 || (_Use408 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1442,
    y: 1022
  })), _Use409 || (_Use409 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 1022
  })), _Use410 || (_Use410 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 98,
    y: 1064
  })), _Use411 || (_Use411 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 140,
    y: 1064
  })), _Use412 || (_Use412 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 1064
  })), _Use413 || (_Use413 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 308,
    y: 1064
  })), _Use414 || (_Use414 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 350,
    y: 1064
  })), _Use415 || (_Use415 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 1064
  })), _Use416 || (_Use416 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 1064
  })), _Use417 || (_Use417 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 1064
  })), _Use418 || (_Use418 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 1064
  })), _Use419 || (_Use419 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 1064
  })), _Use420 || (_Use420 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 1064
  })), _Use421 || (_Use421 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 1064
  })), _Use422 || (_Use422 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 1064
  })), _Use423 || (_Use423 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 1064
  })), _Use424 || (_Use424 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 1064
  })), _Use425 || (_Use425 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 1064
  })), _Use426 || (_Use426 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 1064
  })), _Use427 || (_Use427 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1442,
    y: 1064
  })), _Use428 || (_Use428 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1484,
    y: 1064
  })), _Use429 || (_Use429 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 1064
  })), _Use430 || (_Use430 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 1106
  })), _Use431 || (_Use431 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 98,
    y: 1106
  })), _Use432 || (_Use432 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 1106
  })), _Use433 || (_Use433 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 1106
  })), _Use434 || (_Use434 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 1106
  })), _Use435 || (_Use435 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 1106
  })), _Use436 || (_Use436 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 1106
  })), _Use437 || (_Use437 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 1106
  })), _Use438 || (_Use438 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 1106
  })), _Use439 || (_Use439 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 1106
  })), _Use440 || (_Use440 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 1106
  })), _Use441 || (_Use441 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 1106
  })), _Use442 || (_Use442 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 1106
  })), _Use443 || (_Use443 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 1106
  })), _Use444 || (_Use444 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 1106
  })), _Use445 || (_Use445 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 1106
  })), _Use446 || (_Use446 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 1106
  })), _Use447 || (_Use447 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 1106
  })), _Use448 || (_Use448 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1442,
    y: 1106
  })), _Use449 || (_Use449 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 1106
  })), _Use450 || (_Use450 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 1148
  })), _Use451 || (_Use451 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 140,
    y: 1148
  })), _Use452 || (_Use452 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 308,
    y: 1148
  })), _Use453 || (_Use453 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 350,
    y: 1148
  })), _Use454 || (_Use454 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 1148
  })), _Use455 || (_Use455 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 1148
  })), _Use456 || (_Use456 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 1148
  })), _Use457 || (_Use457 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 1148
  })), _Use458 || (_Use458 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 1148
  })), _Use459 || (_Use459 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 1148
  })), _Use460 || (_Use460 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 1148
  })), _Use461 || (_Use461 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1442,
    y: 1148
  })), _Use462 || (_Use462 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 1148
  })), _Use463 || (_Use463 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 1148
  })), _Use464 || (_Use464 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 1190
  })), _Use465 || (_Use465 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 140,
    y: 1190
  })), _Use466 || (_Use466 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 182,
    y: 1190
  })), _Use467 || (_Use467 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 224,
    y: 1190
  })), _Use468 || (_Use468 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 266,
    y: 1190
  })), _Use469 || (_Use469 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 1190
  })), _Use470 || (_Use470 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 1190
  })), _Use471 || (_Use471 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 1190
  })), _Use472 || (_Use472 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 1190
  })), _Use473 || (_Use473 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 1190
  })), _Use474 || (_Use474 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 1190
  })), _Use475 || (_Use475 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 1190
  })), _Use476 || (_Use476 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 1190
  })), _Use477 || (_Use477 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 1190
  })), _Use478 || (_Use478 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 1190
  })), _Use479 || (_Use479 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 1190
  })), _Use480 || (_Use480 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 1190
  })), _Use481 || (_Use481 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 1190
  })), _Use482 || (_Use482 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 56,
    y: 1232
  })), _Use483 || (_Use483 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 308,
    y: 1232
  })), _Use484 || (_Use484 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 350,
    y: 1232
  })), _Use485 || (_Use485 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 1232
  })), _Use486 || (_Use486 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 1232
  })), _Use487 || (_Use487 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 1232
  })), _Use488 || (_Use488 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 1232
  })), _Use489 || (_Use489 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 1232
  })), _Use490 || (_Use490 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 1232
  })), _Use491 || (_Use491 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 1232
  })), _Use492 || (_Use492 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 1232
  })), _Use493 || (_Use493 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 1232
  })), _Use494 || (_Use494 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 1232
  })), _Use495 || (_Use495 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 1232
  })), _Use496 || (_Use496 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 1232
  })), _Use497 || (_Use497 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 1232
  })), _Use498 || (_Use498 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 1232
  })), _Use499 || (_Use499 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1484,
    y: 1232
  })), _Use500 || (_Use500 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 1232
  })), _Use501 || (_Use501 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 1232
  })), _Use502 || (_Use502 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 1274
  })), _Use503 || (_Use503 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 1274
  })), _Use504 || (_Use504 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 1274
  })), _Use505 || (_Use505 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 1274
  })), _Use506 || (_Use506 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 1274
  })), _Use507 || (_Use507 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 1274
  })), _Use508 || (_Use508 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 1274
  })), _Use509 || (_Use509 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 1274
  })), _Use510 || (_Use510 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 1274
  })), _Use511 || (_Use511 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 1274
  })), _Use512 || (_Use512 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 1274
  })), _Use513 || (_Use513 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 1274
  })), _Use514 || (_Use514 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 1274
  })), _Use515 || (_Use515 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 1274
  })), _Use516 || (_Use516 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 1274
  })), _Use517 || (_Use517 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 1316
  })), _Use518 || (_Use518 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 1316
  })), _Use519 || (_Use519 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 1316
  })), _Use520 || (_Use520 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 1316
  })), _Use521 || (_Use521 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 1316
  })), _Use522 || (_Use522 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 1316
  })), _Use523 || (_Use523 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 1316
  })), _Use524 || (_Use524 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 1316
  })), _Use525 || (_Use525 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 1316
  })), _Use526 || (_Use526 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 1316
  })), _Use527 || (_Use527 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1442,
    y: 1316
  })), _Use528 || (_Use528 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 1316
  })), _Use529 || (_Use529 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 1316
  })), _Use530 || (_Use530 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 1358
  })), _Use531 || (_Use531 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 1358
  })), _Use532 || (_Use532 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 1358
  })), _Use533 || (_Use533 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 1358
  })), _Use534 || (_Use534 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 1358
  })), _Use535 || (_Use535 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 1358
  })), _Use536 || (_Use536 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 1358
  })), _Use537 || (_Use537 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 1358
  })), _Use538 || (_Use538 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 1358
  })), _Use539 || (_Use539 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 1358
  })), _Use540 || (_Use540 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 1358
  })), _Use541 || (_Use541 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 1358
  })), _Use542 || (_Use542 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 1358
  })), _Use543 || (_Use543 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 1358
  })), _Use544 || (_Use544 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 1358
  })), _Use545 || (_Use545 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 1400
  })), _Use546 || (_Use546 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 1400
  })), _Use547 || (_Use547 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 1400
  })), _Use548 || (_Use548 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 1400
  })), _Use549 || (_Use549 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 1400
  })), _Use550 || (_Use550 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 1400
  })), _Use551 || (_Use551 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 1400
  })), _Use552 || (_Use552 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 1400
  })), _Use553 || (_Use553 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 1400
  })), _Use554 || (_Use554 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 1400
  })), _Use555 || (_Use555 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 1400
  })), _Use556 || (_Use556 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 1400
  })), _Use557 || (_Use557 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 1400
  })), _Use558 || (_Use558 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 1400
  })), _Use559 || (_Use559 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 1400
  })), _Use560 || (_Use560 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 1400
  })), _Use561 || (_Use561 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 1400
  })), _Use562 || (_Use562 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 1400
  })), _Use563 || (_Use563 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 1400
  })), _Use564 || (_Use564 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 1400
  })), _Use565 || (_Use565 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1484,
    y: 1400
  })), _Use566 || (_Use566 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 1400
  })), _Use567 || (_Use567 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 1400
  })), _Use568 || (_Use568 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 1442
  })), _Use569 || (_Use569 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 1442
  })), _Use570 || (_Use570 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 1442
  })), _Use571 || (_Use571 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 1442
  })), _Use572 || (_Use572 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 686,
    y: 1442
  })), _Use573 || (_Use573 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 1442
  })), _Use574 || (_Use574 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 896,
    y: 1442
  })), _Use575 || (_Use575 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 1442
  })), _Use576 || (_Use576 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 1442
  })), _Use577 || (_Use577 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 1442
  })), _Use578 || (_Use578 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 1442
  })), _Use579 || (_Use579 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 1442
  })), _Use580 || (_Use580 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 1442
  })), _Use581 || (_Use581 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1442,
    y: 1442
  })), _Use582 || (_Use582 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1484,
    y: 1442
  })), _Use583 || (_Use583 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 392,
    y: 1484
  })), _Use584 || (_Use584 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 434,
    y: 1484
  })), _Use585 || (_Use585 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 518,
    y: 1484
  })), _Use586 || (_Use586 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 1484
  })), _Use587 || (_Use587 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 1484
  })), _Use588 || (_Use588 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 728,
    y: 1484
  })), _Use589 || (_Use589 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 1484
  })), _Use590 || (_Use590 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 938,
    y: 1484
  })), _Use591 || (_Use591 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 1484
  })), _Use592 || (_Use592 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 1484
  })), _Use593 || (_Use593 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 1484
  })), _Use594 || (_Use594 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 1484
  })), _Use595 || (_Use595 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 1484
  })), _Use596 || (_Use596 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 1484
  })), _Use597 || (_Use597 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 1484
  })), _Use598 || (_Use598 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 1484
  })), _Use599 || (_Use599 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 1484
  })), _Use600 || (_Use600 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 1526
  })), _Use601 || (_Use601 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 644,
    y: 1526
  })), _Use602 || (_Use602 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 812,
    y: 1526
  })), _Use603 || (_Use603 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 1526
  })), _Use604 || (_Use604 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 1526
  })), _Use605 || (_Use605 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1190,
    y: 1526
  })), _Use606 || (_Use606 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1232,
    y: 1526
  })), _Use607 || (_Use607 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1274,
    y: 1526
  })), _Use608 || (_Use608 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 1526
  })), _Use609 || (_Use609 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 1526
  })), _Use610 || (_Use610 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 1526
  })), _Use611 || (_Use611 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 476,
    y: 1568
  })), _Use612 || (_Use612 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 560,
    y: 1568
  })), _Use613 || (_Use613 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 602,
    y: 1568
  })), _Use614 || (_Use614 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 770,
    y: 1568
  })), _Use615 || (_Use615 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 854,
    y: 1568
  })), _Use616 || (_Use616 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 980,
    y: 1568
  })), _Use617 || (_Use617 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1022,
    y: 1568
  })), _Use618 || (_Use618 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1064,
    y: 1568
  })), _Use619 || (_Use619 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1106,
    y: 1568
  })), _Use620 || (_Use620 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1148,
    y: 1568
  })), _Use621 || (_Use621 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1316,
    y: 1568
  })), _Use622 || (_Use622 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1358,
    y: 1568
  })), _Use623 || (_Use623 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1400,
    y: 1568
  })), _Use624 || (_Use624 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1442,
    y: 1568
  })), _Use625 || (_Use625 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1484,
    y: 1568
  })), _Use626 || (_Use626 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1526,
    y: 1568
  })), _Use627 || (_Use627 = /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#qr_code_app_store_svg__a",
    x: 1568,
    y: 1568
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M308 98v210H98V98ZM56 56v294h294V56Z"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M140 140h126v126H140zM1568 98v210h-210V98Zm-252-42v294h294V56Z"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    d: "M1400 140h126v126h-126zM308 1358v210H98v-210Zm-252-42v294h294v-294Z"
  })), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    d: "M140 1400h126v126H140z"
  })));
};
export default SvgQrCodeAppStore;